import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/user";
import singproGoods from "./modules/singproGoods";
import pageConfig from "./modules/pageConfig";
import lang from "./modules/lang";
import temporary from "./modules/temporary";
import getters from "./getters";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    user,
    singproGoods,
    pageConfig,
    lang,
    temporary
  },
  getters
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js